const $ = require("jquery");
require("slick-carousel");

/**
 * M7: turns the CAT page's "business type" card grid (.cat__subcat-grid)
 * into a horizontal swiper below $mob (767px), reusing the reviews block's
 * own slick mechanism and arrow markup (.reviews-block__arrow) so swipe,
 * arrows, and slide sizing match. Desktop/tablet keep the plain CSS grid:
 * slick is only ever initialised while the viewport matches, and is torn
 * down (unslick) the moment it stops matching.
 *
 * Markup: any page's cat__subcat-grid, e.g. subcategories.html.twig or
 * section--sub-cat-list.html.twig. Self-initialises on DOM ready and does
 * nothing when the grid is absent, so it is safe to require from an entry
 * shared by several pages.
 *
 * Require this from a page JS entry:
 *   require("../../components/ui-components/subcatCarousel");
 */
function initSubcatCarousel() {
    const $grid = $(".cat__subcat-grid");
    if (!$grid.length) {
        return;
    }

    const mq = window.matchMedia("(max-width: 767px)");
    const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    // Read translated labels from the grid's own data attributes when a page sets
    // them (see sports-fitness/subcategories.html.twig); fall back to plain
    // English so this still works for a page that hasn't added them yet.
    const prevLabel = $grid.data("prev-label") || "Previous business types";
    const nextLabel = $grid.data("next-label") || "Next business types";

    function enable() {
        if ($grid.hasClass("slick-initialized")) {
            return;
        }
        $grid.slick({
            // Two cards wherever there is room for them. Below 600px a single
            // card is all that fits; between 601 and 767 the design asks for
            // more than one rather than one card stretched to the full width.
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                { breakpoint: 600, settings: { slidesToShow: 1 } }
            ],
            infinite: true,
            speed: 300,
            dots: false,
            arrows: true,
            appendArrows: $grid.closest(".container"),
            prevArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + "</button>",
            nextArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + "</button>"
        });
    }

    function disable() {
        if ($grid.hasClass("slick-initialized")) {
            $grid.slick("unslick");
        }
    }

    function onChange(e) {
        if (e.matches) {
            enable();
        } else {
            disable();
        }
    }

    if (mq.addEventListener) {
        mq.addEventListener("change", onChange);
    } else {
        mq.addListener(onChange); // Safari < 14
    }

    if (mq.matches) {
        enable();
    }
}

$(function () {
    initSubcatCarousel();
});

module.exports = { initSubcatCarousel };
